import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Typography,
  makeStyles,
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import React from 'react'

import colors from '../../../../assets/colors'

const useStyles = makeStyles({
  accordion: {
    boxShadow: 'none',
    border: '1px solid',
    borderRadius: '12px !important',
    borderColor: colors.graylight,
    '&:before': {
      display: 'none',
    },
    '&:not(:last-child)': {
      marginBottom: '8px',
    },
  },
  question: {
    fontSize: '13px',
    fontWeight: 'bold',
    color: colors.textCustom,
  },
  answer: {
    fontSize: '13px',
    color: colors.textPrimary,
  },
})

const ImportantInfo = ({ faqs = [] }) => {
  const classes = useStyles()

  if (!faqs.length) return null

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        {faqs.map(faq => (
          <Accordion key={faq.question} className={classes.accordion}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`${faq.question}-content`}
            >
              <Typography className={classes.question}>
                {faq.question}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography className={classes.answer}>{faq.answer}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Grid>
    </Grid>
  )
}

export default ImportantInfo
